import ImageContainer from "../../Images/ImageContainer";

export class ChairRender {
    constructor(room, imageUrl) {
        this.imageObject = ImageContainer.getInstance().image(imageUrl);

        this.imageObject.load().then(() => {
            room.needsRendering = true;
        });
    }

    render(ctx, centerX, centerY, radius, angle) {
        if (this.imageObject && this.imageObject.loaded) {
            let image = this.imageObject.getImage()
            let ratio = image.width / image.height
            let chairsizeX = 30;
            let chairsizeY = chairsizeX / ratio;
            radius += chairsizeX / 2
            let x = centerX + (radius * Math.cos(angle));
            let y = centerY + (radius * Math.sin(angle));
            let rotationAngle = angle + (Math.PI / 2);
            ctx.translate(x, y);
            ctx.rotate(rotationAngle);
            try {
                ctx.drawImage(image, -(chairsizeX / 2), -(chairsizeY / 2), chairsizeX, chairsizeY);
            } catch (e) {
                console.warn(e);
            }
            ctx.rotate(-rotationAngle);
            ctx.translate(-x, -y);
        }
    }
}